import React, { useEffect, useState } from 'react';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { Link, useLocation } from 'react-router-dom';
import { useFormik } from "formik";
import * as Yup from "yup";
import '../../pages/Signup.css';
import { getUserDetails, updateUserDetails } from '../../utils/api';
import Spinner from '../../components/Spinner/Spinner';
import Swal from 'sweetalert2'

function Settings() {
  const location = useLocation()
  const [isPageLoading, setIsPageLoading] = useState(true);
  const userId = localStorage.getItem('userid');
  const [initialValues, setInitialValues] = useState({});
  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Dashboard Settings Page' });
    async function setUserDetails() {
      setIsPageLoading(true);
      const data = await getUserDetails(userId);
      const { email, firstName, lastName, companyOrOrganization, userType, zipcode, country } = data;
      setInitialValues({
        firstName: firstName,
        lastName: lastName,
        companyOrOrganization: companyOrOrganization,
        email: email,
        zipcode: zipcode,
        country: country,
        userType: userType,
      })
      setIsPageLoading(false);
    }
    setUserDetails();
  }, []);

  return (
    <>
    <div className="layout-wrapper layout-content-navbar">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Settings</title>
      </Helmet>
      {
        isPageLoading ? <div style={{height: '3rem', width: '100%', display: 'flex', justifyContent: 'center', marginTop: '15rem'}}> <Spinner color='#015a92' /> </div> : <div style={{justifyContent: 'center', paddingTop: '5rem'}} className="layout-container">
        <div style={{width: '85%'}}>
          <div style={{textAlign: 'left', paddingLeft: '1.2rem', fontSize: '1.5rem', paddingBottom: '2rem'}}><strong style={{color: '#015a92'}}>Settings</strong></div>
            <div>
              <UserDetailsSetingsForm initialValues={initialValues} userId={userId} />
              <ChangePasswordComponent />
            </div>
        </div>
      </div>
      }
    </div>
    </>
  );
}

export function UserDetailsSetingsForm({initialValues, userId, callbackFunction}) {
  const [isSaveButtonLoading, setIsSaveButtonLoading] = useState(false);
  useEffect(()=>{
    formik.setValues({...initialValues})
  }, [])
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required').max(50, 'Max Character limit reached'),
    lastName: Yup.string().required('Last Name is required').max(50, 'Max Character limit reached'),
    companyOrOrganization: Yup.string().max(100, 'Max Character limit reached'),
    email: Yup.string().email('Invalid email address').required('Email is required').max(320, 'Max Character limit reached'),
    zipcode: Yup.string().required('Zipcode is required').max(15, 'Max Character limit reached'),
    country: Yup.string().required('Country is required'),
    userType: Yup.string().required('Category is required'),
    // password: Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters long').max(20, 'Max Character limit reached'),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: '',
      lastName: '',
      companyOrOrganization: '',
      email: '',
      zipcode: '',
      country: '',
      userType: '',
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
    validationSchema: validationSchema
  });
  async function handleSubmit({firstName, lastName, companyOrOrganization, email, zipcode, country,userType}) {
    setIsSaveButtonLoading(true);
    await updateUserDetails(userId, firstName, lastName, companyOrOrganization, email, zipcode, country, userType);
    Swal.fire({
      title: "Your changes are updated successfully!",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
      timerProgressBar: true
    })
    setIsSaveButtonLoading(false);
    if(callbackFunction) callbackFunction()
  }
  return <form style={{
    display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', rowGap: '2rem'
  }} className='form'>
      <InputComponent inputType="text" formik={formik} placeholder="First Name" property="firstName" />
      <InputComponent inputType="text" formik={formik} placeholder="Last Name" property="lastName" />
      <InputComponent inputType="text" formik={formik} isFullRow={true} placeholder="Company or Organization Name" property="companyOrOrganization" />
      <InputComponent inputType="email" formik={formik} placeholder="Email" property="email" />
      <InputComponent inputType="text" formik={formik} placeholder="Zipcode" property="zipcode" />
      <div>
        <div style={{display: 'flex', alignItems: 'center', paddingTop: '0.35rem'}}>
          <select
            value={formik.values.country}
            className="mb-4"
            style={{width: '100%'}}
            id="country"
            name="country"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="" disabled>Country</option>
            <option value="United States">United States</option>
            <option value="Australia">Australia</option>
            <option value="Canada">Canada</option>
            <option value="New Zealand">New Zealand</option>
            <option value="South Africa">South Africa</option>
            <option value="United Kingdom">United Kingdom</option>
          </select>
        </div>
        <div>
          {formik.touched.country && formik.errors.country && <p style={{ color: 'red', margin: '0', padding: '0' }}>{formik.errors.country}</p>}
        </div>
      </div>
      <div>
        <div style={{display: 'flex', alignItems: 'center', paddingTop: '0.35rem', paddingLeft: '1rem'}}>
          <select
            id="userType"
            name="userType"
            value={formik.values.userType}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="mb-4"
            style={{width: '100%'}}
            aria-label="User type"
          >
            <option value="" disabled>Category</option>
            <option value="individual">Individuals</option>
            <option value="corporate">Corporate Partners</option>
            <option value="educational">Educational Institutions</option>
            <option value="foundations">Foundations and Trusts</option>
          </select>
        </div>
        <div>
          {formik.touched.userType && formik.errors.userType && <p style={{ color: 'red', margin: '0', padding: '0' }}>{formik.errors.userType}</p>}
        </div>
      </div>
      <div style={{ gridColumn: '1 / span 2', display: 'flex', justifyContent: 'center' }}>
        <div onClick={formik.handleSubmit} className='sign-in-submit-button' style={{ height: '3rem', display: 'flex', justifyContent: 'center', padding: '0.5rem', alignItems: 'center', width: '50%'}}>
          {isSaveButtonLoading ? <Spinner color="#2691d9"/> : 'Save Changes'}
        </div>
      </div>
  </form>
}

function ChangePasswordComponent() {
  return <div style={{marginTop: '3rem'}}>
            <div>
              <strong style={{fontSize: '1.2rem', color: '#2691d9', textDecorationLine: 'underline'}}>Use below button to change password:</strong>
            </div>
            <div style={{marginTop: '1.5rem'}}>
            <span>
              <Link to="/site/change-password" style={{
                padding: "0.75rem 0.5rem", background: '#2691d9', color: "white",
                borderRadius: '0.5rem', border: '1px solid black'
                }}>
                  Change Password
              </Link>
            </span>
            </div>
        </div>
}

function InputComponent({formik, property, placeholder, inputType, isFullRow}) {
      return <div style={{gridColumn: isFullRow ? '1 / span 2' : ''}}>
            <div style={{display: 'flex', alignItems: 'center', paddingRight: '2rem'}}>
              <span style={{paddingRight: '1rem', whiteSpace: 'nowrap'}}>{placeholder}</span>
              <input
                type={inputType}
                name={property}
                value={formik.values[property]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            <div>
              {formik.touched[property] && formik.errors[property] && <p style={{ color: 'red', margin: '0', padding: '0' }}>{formik.errors[property]}</p>}
            </div>
          </div>
}

export default Settings;